import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { MaterialModule } from 'src/app/app.materials';
import { CommonModule } from '@angular/common';
import { ConstraintSetterComponent } from '../constraint-setter/constraint-setter.component';
import { PortfolioService } from 'src/app/pages/portfolio/portfolio.service';
import { UtilService } from 'src/app/shared/services/util.service';

export interface EditConstraintsDialogData {
  portfolioId: number;
}

@Component({
  selector: 'app-edit-constraints-dialog',
  templateUrl: './edit-constraints-dialog.component.html',
  standalone: true,
  imports: [MaterialModule, CommonModule, ConstraintSetterComponent]
})
export class EditConstraintsDialogComponent implements OnInit {

  portfolio: any;
  constraints: any[] = [];
  sectors: any[] = [];
  countries: any[] = [];
  assets: any[] = [];
  loading = true;
  error: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<EditConstraintsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditConstraintsDialogData,
    private portfolioService: PortfolioService,
    private util: UtilService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    forkJoin({
      portfolio: this.portfolioService.viewItem(this.data.portfolioId),
      optimization: this.portfolioService.fetchOptimizationData(this.data.portfolioId, true)
    }).subscribe({
      next: (result: any) => {
        this.portfolio = result.portfolio;
        this.constraints = result.optimization?.group_constraints || [];
        this.initConstraintLists();
        this.loading = false;
      },
      error: () => {
        this.error = 'Failed to load portfolio data';
        this.loading = false;
      }
    });
  }

  private initConstraintLists(): void {
    if (!this.portfolio?.securities) return;

    const sectors = [];
    const countries = [];

    this.portfolio.securities.forEach((c: any) => {
      if (c.security_type_equity === 'SHARE') {
        if (c.sector) sectors.push(c.sector);
        if (c.country) countries.push(c.country);
      }
    });

    this.sectors = this.util.keepUniqueObjectOfArray(sectors);
    this.countries = this.util.keepUniqueObjectOfArray(countries);
    this.assets = this.portfolio.securities
      .map((s: any) => ({ ...s, name: s.company_name }))
      .sort((a, b) => (a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1));
  }

  onOptimize(): void {
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
